import {Component, OnInit, AfterViewInit, SecurityContext } from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import {FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms';
import {NotificationsService} from 'angular2-notifications';
import {environment} from '../../../environments/environment';
import {GenericModalComponent} from '../../generic-modal/generic-modal.component';
import {LoginService} from '../../services/login.service';
import {ModalService} from '../../services/modalService/modal.service';
import {ApiService} from '../../services/api.service';
import {UtilsService} from '../../services/utils.service';
import {TranslateService} from '@ngx-translate/core';
import {GoogleAnalyticsService} from '../../services/google-analytics-service';
import {SafeUrlPipe} from '../../services/pipe/safe.url.pipe';
import intlTelInput from 'intl-tel-input';

export interface Model {
    title: string;
    data: any;
}

@Component({
    selector: 'app-create',
    templateUrl: './create.component.html',
    styleUrls: ['./create.component.css'],
    providers: [SafeUrlPipe]
})
export class CreateComponent extends DialogComponent<Model, string> implements OnInit, AfterViewInit {

    title: any;
    signupForm: FormGroup;
    create: any = {};
    action: string;
	data: any;
    captchaSrc: any;
    zohoVisitorSrc: any;
    iti: any;
    countryList: any = ['Afghanistan', 'Aland Islands', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia, Plurinational State of', 'Bonaire, Sint Eustatius and Saba', 'Bosnia and Herzegovina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo, the Democratic Republic of the', 'Cook Islands', 'Costa Rica', 'Cote d’Ivoire', 'Croatia', 'Cuba', 'Curaçao', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands (Malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Territories', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard Island and McDonald Islands', 'Holy See (Vatican City State)', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran, Islamic Republic of', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, Democratic People’s Republic of', 'Korea, Republic of', 'Kuwait', 'Kyrgyzstan', 'Lao People’s Democratic Republic', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macao', 'Macedonia, the former Yugoslav Republic of', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Norway', 'Oman', 'Pakistan', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Qatar', 'Reunion', 'Romania', 'Russian Federation', 'Rwanda', 'Saint Barthélemy', 'Saint Helena, Ascension and Tristan da Cunha', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Martin (French part)', 'Saint Pierre and Miquelon', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Sint Maarten (Dutch part)', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia and the South Sandwich Islands', 'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic', 'Taiwan', 'Tajikistan', 'Tanzania, United Republic of', 'Thailand', 'Timor-Leste', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'Uruguay', 'USA', 'Uzbekistan', 'Vanuatu', 'Venezuela, Bolivarian Republic of', 'Vietnam', 'Virgin Islands, British', 'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'];
    industryList: any = ['Aerospace & Aviation', 'Agriculture & Forestry', 'Architecture, Engineering & Construction (AEC)', 'Automotive OEMs', 'Automotive Suppliers', 'BFSI (Banking, Financial Services, and Insurance)', 'Chemicals/Biotechnology', 'Computer Hardware', 'Computer Software/IT/ITeS', 'Defense', 'EDA (electronics design /chip manufacturing)', 'Education', 'Energy (Oil & Gas, Utility, Power, Water)', 'Environmental Services', 'Geographical Information Systems (GIS)', 'Government/Public Services', 'Health', 'Manufacturing', 'Material Science', 'Media & Entertainment', 'Medical Device', 'Motor Vehicle Manufacturing', 'Others', 'Research', 'Ship Building', 'System Integrators', 'Telecommunications', 'Transportation']
    constructor(dialogService: DialogService,
                private apiService: ApiService,
                private loginService: LoginService,
                private fb: FormBuilder,
                private modalService: ModalService,
                private notifications: NotificationsService,
                private utils: UtilsService,
                private translate: TranslateService,
                private ga: GoogleAnalyticsService,
                private safeUrlPipe: SafeUrlPipe) {
        super(dialogService);
    }

    ngOnInit() {
        this.action = environment.baseURL + '/signin/provider/google';
        // const phoneRegex = /^[0-9\- ()+]+$/i;
        // const phoneRegex = /^[+]?[\s./0-9]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/g
        const phoneRegex = /^[\/0-9]{4,20}?$/i
        const nameRegex = /^(?=.*[A-Za-z])[\u00C0-\u1FFF\u2C00-\uD7FF\w\-\s]+$/;
        const companyRegex = /^[A-Za-z0-9\@\$¥£€\.,:;\'\"\(\)\[\]\{\}<>!\?«»\u00C0-\u1FFF\u2C00-\uD7FF\w\-\s]+$/;
        // const passwordRegex = /^[A-Za-z0-9!@#$%^&*]+$/;
        this.signupForm = this.fb.group({
            'name': ['', Validators.compose([Validators.required, Validators.pattern(nameRegex),
                Validators.minLength(2), Validators.maxLength(50)])],
            'lastname': ['', Validators.compose([Validators.required, Validators.pattern(nameRegex),
                Validators.minLength(2), Validators.maxLength(50)])],
            'email': ['', Validators.compose([Validators.required, Validators.email,
                Validators.minLength(5), Validators.maxLength(50)])],
            'company': ['', Validators.compose([Validators.required, Validators.pattern(companyRegex),
                    Validators.minLength(2), Validators.maxLength(50)])],
            'country': [''],
            'industry': [''],
            'jobtitle': [''],
            'password': ['', Validators.compose([Validators.required,
                Validators.minLength(5), Validators.maxLength(50)])],
            'confirm': ['', Validators.compose([Validators.required,
                Validators.minLength(5), Validators.maxLength(50)])],
            'phone': ['', Validators.compose([Validators.required, Validators.pattern(phoneRegex),
                Validators.maxLength(20)])],
            'captchafield': ['', Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(10)])],
            'agreeToConditions': [false]
        }, {validator: this.customValidator});
        document.getElementsByTagName('body')[0].classList.add('modal-open');
        this.zohoVisitorSrc = environment.zohoVisitTracker;
    }

    ngAfterViewInit() {
        this.generateCaptchaImg();
        const phoneInput = document.getElementById('singup_phone') as HTMLInputElement;

        this.iti = intlTelInput(phoneInput, {
            initialCountry: 'auto',
            geoIpLookup: (callback) => {
                // Use a free IP geolocation service to get the user's country
                fetch(environment.ipGeolocationService)
                .then((res) => res.json())
                .then((data) => callback(data.country_code))
                .catch(() => callback('us'));
            },
            utilsScript: environment.intlTelInputService, // Load utility functions for formatting
        });
    }

    confirm() {
        this.close();
    }
    
    closeSignUp() {
        this.result = 'CLOSE SIGN UP';
        this.close();
    }

    public submit() {
        $(document).ready(function () {
            $('#googlesign').submit();
        });
    }

    createAccount() {
    	this.sendGaEvent('Create free account');
        if (!this.signupForm.valid) {
            this.utils.validateAllFormFields(this.signupForm);
            return;
        }
        if (!this.signupForm.value.agreeToConditions){
            this.modalService.open(GenericModalComponent, {
                data: {
                	message: this.translate.instant('account.create.onlyTerms'),
                	order : 0,
                	addFooterBtn : true,
                	isCancel: true,
                	cancelText: this.translate.instant('common.close'),
                    centered: true
                }
                });
            return;
        }
        let user = this.signupForm.value;
        var dialCode = this.iti.getSelectedCountryData().dialCode;
        user.phone = dialCode + '' + user.phone;
        delete user.confirm;
        user.userInfoIp = '';
        user.userInfoCity = '';
		user.userInfoRegion = '';
		user.userInfoCountry = '';
        this.loginService.getUserInfo().subscribe((res) => {
			user.userInfoIp = res.json().ip ? res.json().ip : '';
			user.userInfoCity = res.json().city ? res.json().city : '';
			user.userInfoRegion = res.json().region ? res.json().region : '';
			user.userInfoCountry = res.json().country ? res.json().country : '';
			this.loginService.createUser(user)
	            .subscribe((res) => {
	            	window.location.href='/#/home';
	                this.close();
	                // this.notifications.success('Success', 'Please check your email to complete registration');
	                this.modalService.open(GenericModalComponent, {
	                    title: this.translate.instant('common.success'),
	                    data: {
	                        message: this.translate.instant('account.create.emailCheck'),
		                	order : 0,
		                	addFooterBtn : true,
		                	isCancel: true,
		                	cancelText: this.translate.instant('common.close'),
		                    centered: true
	                    }
	                }).subscribe((modal) => {
	                	if(this.data && this.data.winReload) {
	                		window.location.href='/#/home';
	                		window.location.reload();
	                	}
	                });
	            }, (error) => {
	            	if(error.status == 0) {
	            		window.location.href='/#/error-page';
	            		this.close();
	              	} else {
                        this.generateCaptchaImg();
                        this.signupForm.controls['captchafield'].setValue("");
		                this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('account.create.fail')));
	              	}
	            });
        }, (error) => {
        	console.log(error);
        	this.loginService.createUser(user)
	            .subscribe((res) => {
	            	window.location.href='/#/home';
	                this.close();
	                // this.notifications.success('Success', 'Please check your email to complete registration');
	                this.modalService.open(GenericModalComponent, {
	                    title: this.translate.instant('common.failed'),
	                    data: {
	                        message: this.translate.instant('account.create.emailCheck'),
		                	order : 0,
		                	addFooterBtn : true,
		                	isCancel: true,
		                	cancelText: this.translate.instant('common.close'),
		                    centered: true
	                    }
	                }).subscribe((modal) => {
	                	if(this.data && this.data.winReload) {
	                		window.location.href='/#/home';
	                		window.location.reload();
	                	}
	                });
	            }, (error) => {
	            	if(error.status == 0) {
	            		window.location.href='/#/error-page';
	            		this.close();
	              	} else {
	              		this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('account.create.fail')));
	              	}
	            });
        });
        
    }

    customValidator(group: FormGroup) {
        const newPassword = group.controls.password.value;
        const confirmPassword = group.controls.confirm.value;
        return newPassword === confirmPassword ? null : {notEqual: true};
    }
    
    sendGaEvent(ea) {
	  	this.ga.emitEvent('Create account form', ea, 'Click');
	}
    
    openSignInAccountModal() {
    	this.ga.emitEvent('Create account form', 'Already have an account?', 'Click');
        this.result = 'SIGN IN';
        this.close();
    }

    generateCaptchaImg() {
        var captcha = document.getElementById('captchaImg') as HTMLImageElement;
        captcha.src = this.apiService.getCaptchaImgURL();
    }

    countrySelectOnChange() {
    	var countrySelect = document.getElementById('country') as HTMLSelectElement;
        countrySelect.classList.add('black');
    }

    industrySelectOnChange() {
    	var industrySelect = document.getElementById('industry') as HTMLSelectElement;
        industrySelect.classList.add('black');
    }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/account/create/create.component.ts